/**
 * The regexs based on data by RDW
 * http://www.rdw.nl/Particulier/Paginas/Uitleg-over-de-cijfers-en-letters-op-de-kentekenplaat.aspx?path=Portal/Particulier/De%20kentekenplaat/Het%20kenteken%20op%20de%20plaat
 */
const licensePlateRegexs = [
    /^([A-Z]{2})-?([0-9]{2})-?([0-9]{2})$/ /* 1951 XX-99-99 Serie 1 */,
    /^([0-9]{2})-?([0-9]{2})-?([A-Z]{2})$/ /* 1965 99-99-XX Serie 2 */,
    /^([0-9]{2})-?([A-Z]{2})-?([0-9]{2})$/ /* 1973 99-XX-99 Serie 3 */,
    /^([BDF-HJ-NPR-TV-Z]{2})-?([0-9]{2})-?([BDF-HJ-NPR-TV-Z]{2})$/ /* 1978 XX-99-XX Serie 4 */,
    /^([BDF-HJ-NPR-TV-Z]{2})-?([BDF-HJ-NPR-TV-Z]{2})-?([0-9]{2})$/ /* 1991 XX-XX-99 Serie 5 */,
    /^([0-9]{2})-?([BDF-HJ-NPR-TV-Z]{2})-?([BDF-HJ-NPR-TV-Z]{2})$/ /* 1999 99-XX-XX Serie 6 */,
    /^([0-9]{2})-?([BDF-HJ-NPR-TV-Z]{3})-?([0-9]{1})$/ /* 2005 99-XXX-9 Serie 7 */,
    /^([0-9]{1})-?([BDF-HJ-NPR-TV-Z]{3})-?([0-9]{2})$/ /* 2009 9-XXX-99 Serie 8 */,
    /^([BDF-HJ-NPR-TV-Z]{2})-?([0-9]{3})-?([BDF-HJ-NPR-TV-Z]{1})$/ /* 2006 XX-999-X Serie 9 */,
    /^([BDF-HJ-NPR-TV-Z]{1})-?([0-9]{3})-?([BDF-HJ-NPR-TV-Z]{2})$/ /* 2008 X-999-XX Serie 10 */,
    /^([BDF-HJ-NPR-TV-Z]{3})-?([0-9]{2})-?([BDF-HJ-NPR-TV-Z]{1})$/ /* 2015 XXX-99-X Serie 11 */,
    /^([A-Z]{1})-?([0-9]{2})-?([A-Z]{3})$/ /* 2024 X-99-XXX Serie 12 */,
    /* The following series are not use yet in the Netherlands
Uncomment once they are */
    // /^([0-9]{1})-?([A-Z]{2})-?([0-9]{3})$/ /* 9-AA-999 Serie 13 */,
    // /^([0-9]{3})-?([A-Z]{2})-?([0-9]{1})$/ /* 999-AA-9 Serie 14 */,
];
/**
 * This will only validate if the provided licenseplate was valid
 * @param licensePlate A string representing the licenceplate
 * @return true or false depending on a validity of a license plate
 */
export const validateLicensePlate = (licensePlate = '') => licensePlateRegexs.some((pattern) => pattern.test(formatLicensePlate(licensePlate)));
/**
 * This strips the provided licenseplate. The function returns a
 * formatted and stripped string for use in API requests
 * @param licensePlate A string representing the licenceplate
 * @return a string representing the sanitised licenseplate if formatting was successful
 */
export const sanitiseLicensePlate = (licensePlate) => licensePlate.replace(/[^0-9A-Za-z]/g, '').toLowerCase();
/**
 * This will validate if the provided license plate is valid and will return a nicely formatted string seperated by a dash if it is
 * @param licensePlate A string representing the licenceplate
 * @return		       A string representing a formatted licenseplate if formtaing was successful
 */
export const formatLicensePlate = (licensePlate = '') => {
    let licensePlateFormatted = licensePlate.toUpperCase().replace(/[^A-Z0-9\-\\s]/g, '');
    return licensePlateRegexs.some((pattern) => {
        if (pattern.test(licensePlateFormatted)) {
            licensePlateFormatted = licensePlateFormatted.replace(pattern, '$1-$2-$3');
            return true;
        }
        return false;
    })
        ? licensePlateFormatted
        : licensePlate;
};
